<div class="Notitzen todos">
  <div class="col">
    @for (item of Items; track item.key) {
    <div class="row todo" [class.Week]="hasOneWeek(item)" [class.Over]="isOverDu(item)" [class.Finish]="item.erledigt">
      <div class="col">
        <div class="row">
          <div class="col text-Col">
            <strong>
              {{item.titel}}
            </strong>
          </div>
          <div class="col-auto">
            @if(!item.erledigt)
            {
            <i class="bi bi-check-lg" (click)="SetFinished(item)" style=" font-size: xx-large; color: green; display: inline-block; width: 32px; cursor: pointer; height: 32px; margin: 0 15px; vertical-align: middle; line-height: 32px; "></i>
            <i class="bi bi-pencil-fill" (click)="selectItem(item)" style=" font-size: x-large; color: black; display: inline-block; width: 32px; cursor: pointer; height: 32px; margin: 0 15px; vertical-align: bottom; line-height: 32px; "></i>
            }
          </div>
        </div>
        <div class="row">
          <div class="col text-Col">
            {{item.info}}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <strong>Zu erledigen Bis:</strong> {{item.zuErledigenBis | date:'dd.MM.yyyy'}}
          </div>
          <div class="col">
            <strong>Kürtzel:</strong> {{item.kuerzel}}
          </div>
          <div class="col">
            @if(item.erledigt)
            {
            <div class="col">
              <strong>Erledigt Am:</strong> {{item.erledigtAm | date:'dd.MM.yyyy'}}
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>
<div class="TodoEdit row">
  <div class="col"></div>
  <div class="col-auto">
    <div class="btn btn-success" (click)="newItem()">Hinzufügen</div>
  </div>
</div>
@if(EditItem != null)
{
<div class="SelectTypeDialogmodal" tabindex="-1" (keyup.enter)="CreateUpdate()">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Todo</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="Close()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="form-floating mb-3">
              <Date-Select [(Date)]="EditItem.zuErledigenBis" LabelText="Zu erledigen Bis"></Date-Select>
            </div>
          </div>
          <div class="col">
            <div class="form-floating mb-3">
              <input type="text" class="form-control" id="kuerzel" [(ngModel)]="EditItem.kuerzel">
              <label for="kuerzel">Kürzel</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-floating mb-3">
              <input type="text" class="form-control" id="titel" [(ngModel)]="EditItem.titel">
              <label for="titel">Titel</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-floating mb-3">
              <textarea type="text" class="form-control" id="info" [(ngModel)]="EditItem.info"></textarea>
              <label for="info">Info</label>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="CreateUpdate()">Speichern</button>
      </div>
    </div>
  </div>
</div>
}
